module.exports = __webpack_public_path__ + "static/media/hero_section_idea.cf82f4fa.svg";